import { useSettingsStore } from "@/data/settingsStore";

export interface MediathequeVideo {
  id: string;
  title: string;
  youtubeUrl: string; // The URL entered by the admin, e.g., https://www.youtube.com/watch?v=XXXX or https://youtu.be/XXXX
  embedUrl?: string; // The parsed embed URL for the iframe
  createdAt: string;
  published: boolean;
}

const STORAGE_KEY = "kayninMediatheque";

const defaultVideos: MediathequeVideo[] = [
  {
    id: "vid_1",
    title: "Le Grand Débat : Élections 2026",
    youtubeUrl: "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
    embedUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    createdAt: new Date().toISOString(),
    published: true,
  },
  {
    id: "vid_2",
    title: "Analyse des programmes politiques",
    youtubeUrl: "https://youtu.be/aqz-KE-bpKQ",
    embedUrl: "https://www.youtube.com/embed/aqz-KE-bpKQ",
    createdAt: new Date(Date.now() - 86400000).toISOString(),
    published: true,
  }
];

// Helper to extract YouTube video ID and create embed URL
export function getYoutubeEmbedUrl(url: string): string | undefined {
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
  const match = url.match(regExp);
  if (match && match[2].length === 11) {
    return `https://www.youtube.com/embed/${match[2]}`;
  }
  return undefined;
}

export function getVideos(): MediathequeVideo[] {
  const cached = useSettingsStore.getState().getSetting(STORAGE_KEY, "");
  if (cached && typeof cached === "string") {
    try {
      return JSON.parse(cached);
    } catch {}
  }
  return defaultVideos;
}

export function saveVideos(videos: MediathequeVideo[]) {
  useSettingsStore.getState().updateSetting(STORAGE_KEY, JSON.stringify(videos));
}

export function addVideo(title: string, youtubeUrl: string) {
  const videos = getVideos();
  const newVideo: MediathequeVideo = {
    id: `vid_${Date.now()}`,
    title,
    youtubeUrl,
    embedUrl: getYoutubeEmbedUrl(youtubeUrl),
    createdAt: new Date().toISOString(),
    published: true,
  };
  const updatedVideos = [newVideo, ...videos].slice(0, 12);
  saveVideos(updatedVideos);
  return newVideo;
}

export function toggleVideoPublish(id: string) {
  const videos = getVideos().map(v => 
    v.id === id ? { ...v, published: !v.published } : v
  );
  saveVideos(videos);
}

export function deleteVideo(id: string) {
  const videos = getVideos().filter(v => v.id !== id);
  saveVideos(videos);
}
